export default async function ({ store, route, params, redirect, $localForage }) {
  // We'll only apply this middleware to setting routes.
  if (!route.path.startsWith('/settings')) {
    return;
  }

  let ignoreRedirect = false;
  const domain = window.location.hostname;

  // sometimes the redirect triggers twice but without the query parameter on the second time, so we set a window flag to ignore the second redirect if it happens.
  // a refresh will reset the session
  if (domain === 'staging.plannr.dev' || $nuxt.$config.environment === 'development') {
    if (route.query['ignore-redirect']) {
      window.ignoreNuxtRedirect = true;
    }
    ignoreRedirect = !!window?.ignoreNuxtRedirect || false;

    if (ignoreRedirect) {
      console.log(
        '⚠️ Ignoring redirect to Nuxt 4 settings page due to ignore-redirect query parameter or window flag. ⚠️'
      );
    }
  }

  // Specify any custom route mappings if the route signatures have changed between Nuxt 2 and Nuxt 4.
  // Any not specified will be passed directly to Nuxt 4. (e.g. source: destination)

  const routeMapper = {
    '/settings/preferences': '/settings/account/preferences',
    '/settings': '/settings/dashboard',
    '/settings/account-details': '/settings/account/details',
    '/settings/email': '/settings/account/mailboxes',
  };

  // Check local storage for menu state to preserve it across the redirect
  let menuOpen = false;
  if (process.client && store.state.user.currentAccount) {
    const accountUuid = store.state.user.currentAccount.uuid;
    const stickyData = await $localForage.getItem(`${accountUuid}-menuOpen`);
    menuOpen = stickyData === true;
  }

  const destinationPath = routeMapper[route.path] ?? route.path;

  let query = { ...route.query };
  // Only add menuCollapsed query param when menu is collapsed
  if (!menuOpen) {
    query.menuCollapsed = 'true';
  } else {
    query.menuCollapsed = 'false';
  }

  const queryString = Object.keys(query).length ? '?' + new URLSearchParams(query).toString() : '';

  if (routeMapper[route.path] && !ignoreRedirect) {
    return redirect($nuxt.$config.plannrNextURL + destinationPath + queryString);
  } else return;
}
